import { imageBuilder, linkBuilder } from '@noths/polaris-client-data-builders';

import { partnerBuilder, priceBuilder } from '.';
import { SimilarProduct } from 'src/types';

const defaults: Readonly<SimilarProduct> = {
  availability: 'available',
  code: 0,
  images: [
    imageBuilder({
      title: 'Posh Chipmonks',
      href: 'http://images/posh_chipmonks_{size}.jpg',
    }),
  ],
  inventory_status: 'in_stock',
  free_domestic_delivery: false,
  links: [
    linkBuilder({
      title: 'Cushions',
      rel: '/home/cushions',
      href: 'https://www.notonthehighstreet.com/home/cushions',
    }),
  ],
  new: false,
  on_sale: false,
  partner: partnerBuilder({ shortcode: 'aliceandjoe', name: 'Alice and Joe' }),
  prices: [priceBuilder()],
  purchasable: true,
  title: 'Smurfs Vs Dinosaurs: The Epic Saga That Never Happened',
  linkURL: '',
};

export const similarProductBuilder = (
  recommendedProduct?: Partial<SimilarProduct>,
): Readonly<SimilarProduct> => ({
  ...defaults,
  ...recommendedProduct,
});
